import {
  type SizeFilterDepartment,
  type SizeFilterGroup,
  type SizeFilterSize,
  type SizeFiltersResponse,
} from './aliases';

export type SizeFilterGroupForCountry = Omit<SizeFilterGroup, 'children'> & {
  children: SizeFilterSize[];
};

export type SizeFilterDepartmentForCountry = Omit<
  SizeFilterDepartment,
  'children'
> & {
  children: SizeFilterGroupForCountry[];
};

/*
 * Filters the size tree to only show sizes matching the user's country/region,
 * and removes the country level from the tree structure.
 */
export function filterSizesByCountry(
  sizeTree: SizeFiltersResponse,
  targetCountry: string
): SizeFilterDepartmentForCountry[] {
  return sizeTree.flatMap((department) => {
    const groups = department.children.flatMap((group) => {
      const region = group.children.find(
        ({ name }) => name?.toUpperCase() === targetCountry.toUpperCase()
      );

      return region?.children.length
        ? [{ ...group, children: region.children }]
        : [];
    });

    return groups.length > 0 ? [{ ...department, children: groups }] : [];
  });
}
